'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Editor for markers
//***********************************************************************************
//***********************************************************************************
import { cn_marker } from '../model/cn_marker';
import { cn_element } from '../model/cn_element';
import { cn_storey } from '../model/cn_storey';
import { cn_svg_tool_edition } from './cn_svg_tool_edition';
import { cn_svg_map } from './cn_svg_map';
import { cn_user_measure } from '../model/cn_user_measure';
import { cn_user_measure_handler } from './cn_user_measure_handler';

export class cn_svg_tool_user_measure_edition extends cn_svg_tool_edition {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);

        this._handler = null;

        this._marker_class = cn_marker;
    }

    /**
     * Intended for 3d compatible tools. Must return true if the tool can edit the element
     * @param {{element: cn_element, storey: cn_storey}} storey_element
     * @returns {boolean}
     */
    can_edit(storey_element) {
        return storey_element.element.constructor == cn_user_measure;
    }

    //***********************************************************************************
    /**
     * Builds a new marker handler.
     * TODO: derivate this in order to manage marker derivates
     * @param {Array<cn_user_measure>} measures
     * @returns {cn_user_measure_handler}
     */
    _build_handler(measures) {
        return new cn_user_measure_handler(measures, (this._map) ? this._map : this._view_overlay);
    }

    //***********************************************************************************
    on_selection_change() {

        const obj = this;
        this._handler = null;
        this._handlers = [];

        //*** We expect the selection to contain only user measures */
        var sel = (this._view_overlay) ? this._view_overlay.get_selection().map(s => s.element) : this._controller.get_selection();
        if (sel.length == 0 || sel.some(elt => elt.constructor != cn_user_measure))
            return false;

        this._handler = this._build_handler(sel);
        this._handlers.push(this._handler);
        if (this._view_overlay) {
            this._handler.on('shape_changed', () => {
                obj._view_overlay.refresh_3d();
            });
        }
        return true;
    }
}

